"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.List = void 0;
var react_1 = __importDefault(require("react"));
var prop_types_1 = __importDefault(require("prop-types"));
var storybook_1 = require("@eyecons/storybook");
var List = function (_a) {
    var user = _a.user, channel = _a.channel;
    var _b = storybook_1.Hooks.useModal(), Modal = _b[0], setModal = _b[1];
    return react_1.default.createElement(storybook_1.Layouts.Container, { className: 'storybook-layouts-space' },
        react_1.default.createElement(Modal, null),
        react_1.default.createElement(storybook_1.Playlists.Cards, { user: user, channel: channel, onDelete: function (playlist) { return setModal({
                content: function () { return react_1.default.createElement(storybook_1.Forms.DeleteModal, { title: 'afspeellijst', route: 'playlists', api: 'backend', params: { id: playlist.id, channel_id: channel.id } }); }
            }); } }));
};
exports.List = List;
exports.List.propTypes = {
    /**
     * Current user session
     */
    user: prop_types_1.default.shape({
        id: prop_types_1.default.number.isRequired,
    }).isRequired,
    /**
     * Current channel session
     */
    channel: prop_types_1.default.shape({
        id: prop_types_1.default.number.isRequired,
    }).isRequired,
};
